import { ZoomIn, ZoomOut, Maximize } from 'lucide-react';

interface CanvasControlsProps {
  zoom: number;
  onZoomIn: () => void;
  onZoomOut: () => void;
  onReset: () => void;
}

export function CanvasControls({ zoom, onZoomIn, onZoomOut, onReset }: CanvasControlsProps) {
  return (
    <div className="absolute bottom-4 right-4 surface-overlay flex items-center gap-1 p-1.5 z-10">
      <button onClick={onZoomOut} className="p-2 rounded-lg interactive-ghost text-text-secondary">
        <ZoomOut size={14} />
      </button>
      <span className="text-micro text-text-muted font-mono w-10 text-center tabular-nums">
        {Math.round(zoom * 100)}%
      </span>
      <button onClick={onZoomIn} className="p-2 rounded-lg interactive-ghost text-text-secondary">
        <ZoomIn size={14} />
      </button>
      <button onClick={onReset} className="p-2 rounded-lg interactive-ghost text-text-secondary" title="Reset view">
        <Maximize size={14} />
      </button>
    </div>
  );
}
